import { connect, ConnectedProps } from "react-redux";

import { MobileKeywordSearch } from "./component";
import { IStoreState } from "../../../../reducers/types";
import { actions } from "../../actions";
import {
  getAttractionTags,
  getExperiencesCategoryTags,
  getKeyword,
  getKeywordCategories,
  getKeywordCategoriesLoading,
  getParsedExperiencesByCategory,
} from "../../reducer";
import { getFromDate, getUntilDate } from "../../../search/reducer";

export const mapStateToProps = (state: IStoreState) => {
  const loading = !!getKeywordCategoriesLoading(state);

  return {
    overrideInputValue: undefined,
    value: getKeyword(state),
    valueCategories: getKeywordCategories(state),
    loading,
    fromDate: getFromDate(state),
    untilDate: getUntilDate(state),
    experiencesByCategory: getParsedExperiencesByCategory(state),
    categoryTags: getExperiencesCategoryTags(state),
    attractionTags: getAttractionTags(state),
  };
};

const mapDispatchToProps = {
  setValue: actions.setKeyword,
  fetchValueCategories: actions.fetchExperiencesAvailabilityAutocomplete,
  setFilterTags: actions.setFilterTags,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileKeywordSearchConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileKeywordSearch = connector(MobileKeywordSearch);
